import React from "react";
import { twMerge } from "tailwind-merge";

const ReportTable = ({
  children,
  className,
  disable100Vh = false,
  ...props
}) => {
  return (
    <div
      className={twMerge(
        "relative block flex-grow overflow-auto",
        !disable100Vh && "h-screen"
      )}
    >
      <table
        className={twMerge(
          "w-full table-auto border-separate border-spacing-0",
          className
        )}
        {...props}
      >
        {children}
      </table>
    </div>
  );
};

export default ReportTable;

ReportTable.Head = ({ children, className, ...props }) => {
  return (
    <thead className={twMerge("", className)} {...props}>
      {children}
    </thead>
  );
};

ReportTable.Heading = ({ children, className, ...props }) => {
  return (
    <td
      className={twMerge(
        "sticky top-0 select-none border bg-gray-100 p-2 text-center text-sm dark:border-gray-600 dark:bg-slate-800",
        className
      )}
      {...props}
    >
      {children}
    </td>
  );
};

ReportTable.Body = ({ children, className, ...props }) => {
  return (
    <tbody
      className={twMerge(
        "border border-gray-200 dark:border-gray-600",
        className
      )}
      {...props}
    >
      {children}
    </tbody>
  );
};

ReportTable.Row = ({ children, className, ...props }) => {
  return (
    <tr className={twMerge("", className)} {...props}>
      {children}
    </tr>
  );
};

ReportTable.Data = ({ children, className, ...props }) => {
  return (
    <td
      className={twMerge("border p-2 text-sm dark:border-gray-600", className)}
      {...props}
    >
      {children}
    </td>
  );
};
